import React from 'react';
import { Stack, Typography, Paper } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { WorkflowNameField } from '../fields/WorkflowNameField';
import { WorkflowTriggerField } from '../fields/WorkflowTriggerField';
import { WorkflowDescriptionField } from '../fields/WorkflowDescriptionField';
import { WorkflowActiveSwitch } from '../fields/WorkflowActiveSwitch';

export const BasicInfoSection: React.FC = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: 1.5,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" mb={2}>
        <SettingsIcon sx={{ color: '#3b82f6' }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b' }}>
          Basic Information
        </Typography>
      </Stack>

      <Stack spacing={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} gap={2}>
          <WorkflowNameField />
          <WorkflowTriggerField />
        </Stack>
        <WorkflowDescriptionField />
        <WorkflowActiveSwitch />
      </Stack>
    </Paper>
  );
};

export default BasicInfoSection;
